/**
 * 工具接口-服务站点列表
 */
export const API_SERVICE_SITE_LIST = '/api/serviceSite';
/**
 * 工具接口-网站基础数据的两个二维码
 */
export const API_SITE = '/api/site';
/**
 * 工具接口-客户账户-获取全部城市数据
 */
export const API_CITY_GETCITIESALL = '/api/city/getCitiesAll';
/**
 * 工具接口-客户账户-获取停车优惠原因
 */
export const API_CITY_GETPARKINGBASIC = '/api/basic/getParkingBasic';
/**
 * 工具接口-客户账户-获取会员详情下拉框数据
 */
export const API_CITY_GETACCOUNTBASIC = '/api/basic/getAccountBasic';
/**
 * 工具接口-客户账户-获取黑书会员下拉框数据
 */
export const API_CITY_GETBLACKBOOKMEMBER = '/api/basic/getBlackBookMember';
/**
 * 工具接口-客户账户-获取入会礼包列表
 */
export const API_MEMBERSHIP_CEREMONY_LIST = '/api/member/membershipCeremonyList';
/**
 * 工具接口-预约服务-获取预约项目和预约状态数据
 */
export const API_SUBSCRIBE_OPTIONSTATUS = '/api/subscribe/optionStatus';
/**
 * 工具接口-预约服务-获取贵宾休息室，导购大使，代客泊车的时间和数量,以及次数
 */
export const API_SUBSCRIBE_SURPLUSCOUNTSUBSCRIBE = '/api/subscribe/surplusCountSubscribe';
/**
 * 工具接口-预约服务-获取贵宾休息室预约时间段,代客泊车,导购大使预约时间数据(预约详情时用)
 */
export const API_SUBSCRIBE_TIMESLOTDATA = '/api/subscribe/timeSlotData';
/**
 * 工具接口-预约服务-免提购物-免提购物订单状态数据
 */
export const API_SUBSCRIBE_HANDSFREEDATA = '/api/subscribe/handsfreeData'
/**
 * 工具接口-现场服务-获取大使数据
 */
export const API_BASIC_GETGEPCSLIST = '/api/basic/getGePcsList';
/**
 * 工具接口-现场服务-获取服务下拉框数据
 */
export const API_BASIC_GETSERVICEBASIC = '/api/basic/getServiceBasic';
/**
 * 工具接口-现场服务-获取品牌数据
 */
export const API_BASIC_GETLEASEBRANDLIST = '/api/basic/getLeaseBrandList';
/**
 * 工具接口-现场服务-获取租赁下拉框数据
 */
export const API_BASIC_GETLEASEBASIC = '/api/basic/getLeaseBasic';
/**
 * 工具接口-现场服务-获取商品快递下拉框数据
 */
export const API_BASIC_GETEXPRESSAGEBASIC = '/api/basic/getExpressageBasic';
/**
 * 工具接口-现场服务-获取投诉下拉框数据
 */
export const API_BASIC_GETCASESBASIC = '/api/basic/getCasesBasic';
/**
 * 工具接口-现场服务-获取失物招领下拉框数据
 */
export const API_BASIC_LOSEBASIC = '/api/basic/getLoseBasic';
/**
 * 工具接口-现场服务-获取兑换平台数据
 */
export const API_BASIC_GETEXTERNALGIFTACTLIST = '/api/basic/getExternalgiftActList';
/**
 * 工具接口-小票-获取租赁品牌数据（小票审核列表查询的品牌数据）
 */
export const API_BASIC_GETSERVICEBRANDLIST = '/api/basic/getServiceBrandList';
/**
 * 工具接口-小票-历史小票列表中获取品牌数据
 */
export const API_BASIC_GETBRANDLIST = '/api/basic/getBrandList';
/**
 * 工具接口-小票-销售渠道
 */
export const API_BASIC_GETSALESSOURCE = '/api/basic/getSalesSource';
/**
 * 工具接口-小票-小票中获取拒绝原因
 */
export const API_BASIC_GETREFUSEDESC = '/api/basic/getRefuseDesc';
/**
 * 工具接口-兑换管理-优惠券列表
 */
export const API_TICKET_COUPONSLIST = '/api/ticket/couponsList';
/**
 * 工具接口-兑换管理-活动列表
 */
export const API_TICKET_TICKETACTLIST = '/api/ticket/ticketActList';


/**
 * 登录-登录接口
 */
export const API_USER_LOGIN = '/api/user/login';
/**
 * 登录-发送登录验证码
 */
export const API_USER_SEND_VERIFY = '/api/user/sendVerify';
/**
 * 登录-验证
 */
export const API_USER_VERIFY = '/api/user/verify';
/**
 * 登录-账户详情
 */
export const API_USER_PROFILE = '/api/user/profile';
/**
 * 登录-登出
 */
export const API_USER_LOGOUT = '/api/user/logout';


/**
 * 客户账户-客户列表
 */
export const API_MEMBER_INDEX = '/api/member/index';
/**
 * 客户账户-用户信息
 */
export const API_MEMBER_INFO = '/api/member/info';
/**
 * 客户账户-获取用户最后等级变更信息
 */
export const API_MEMBER_LASTLEVELINFO = '/api/member/lastLevelInfo';
/**
 * 客户账户-非用户信息
 */
export const API_MEMBER_NOTMEMBERINFO = '/api/member/notMemberInfo';
/**
 * 客户账户-发放入会礼放入卡包暂不兑换/发放入会礼并兑换
 */
export const API_MEMBER_SENDMEMBERSHIPCEREMONY = '/api/member/sendMembershipCeremony';
/**
 * 客户账户-校验手机号是否有效
 */
export const API_MEMBER_PHONEVERIFY = '/api/member/phoneVerify';
/**
 * 客户账户-会员升降级
 */
export const API_MEMBER_UPGRADELEVEL = '/api/member/upgradeLevel';
/**
 * 客户账户-邀请成为奕尚
 */
export const API_MEMBER_UPGRADEYISHANG = '/api/member/upgradeYishang';
/**
 * 客户账户-小票记录列表
 */
export const API_MEMBER_RECEIPTLIST = '/api/member/receiptList';
/**
 * 客户账户-删除小票
 */
export const API_MEMBER_DELETETICKET = '/api/member/deleteTicket';
/**
 * 客户账户-兑换记录列表
 */
export const API_MEMBER_CONVERTTICKETLIST = '/api/member/convertTicketList';
/**
 * 客户账户-活动RSVP记录列表
 */
export const API_MEMBER_RSVPLIST = '/api/member/rsvpList';
/**
 * 客户账户-会员操作日志
 */
export const API_MEMBER_MEMBERLOGLIST = '/api/member/memberLogList';
/**
 * 客户账户-添加编辑会员
 */
export const API_MEMBER_ADDEDITMEMBER = '/api/member/addEditMember';
/**
 * 客户账户-添加编辑非会员
 */
export const API_MEMBER_ADDEDITNOTMEMBER = '/api/member/addEditNotMember';
/**
 * 客户账户-优惠停车
 */
export const API_MEMBER_PARKING = '/api/member/parking';
/**
 * 客户账户-优惠停车历史记录
 */
export const API_MEMBER_PARKINGLIST = '/api/member/parkingList';

/**
 * 小票-小票审核列表
 */
export const API_RECEIPT_EXAMINERECEIPTLIST = '/api/receipt/examineReceiptList';
/**
 * 小票-通过或者拒绝审核列表的小票
 */
export const API_RECEIPT_EDITEXAMINERECEIPT = '/api/receipt/editExamineReceipt';
/**
 * 小票-获取小票模块的用户信息
 */
export const API_RECEIPT_MEMBERINFO = '/api/receipt/memberInfo';
/**
 * 小票-上传小票
 */
export const API_RECEIPT_UPLOADRECEIPT = '/api/receipt/uploadReceipt';
/**
 * 小票-重复小票确认后发送邮件
 */
export const API_RECEIPT_CONFIRMRECEIPT = '/api/receipt/confirmReceipt';
/**
 * 小票-扫描上传联营小票
 */
export const API_RECEIPT_SCANRECEIPT = '/api/receipt/scanReceipt';
/**
 * 小票-历史小票记录
 */
export const API_RECEIPT_INDEX = '/api/receipt/index';
/**
 * 小票-修改小票
 */
export const API_RECEIPT_EDITRECEIPT = '/api/receipt/editReceipt';

/**
 * 服务-服务记录列表(用户)
 */
export const API_SERVICE_SERVICELIST = '/api/service/index';
/**
 * 现场服务-匹配客户(获取用户信息或者非用户信息)
 */
export const API_SERVICE_MEMBERINFO = '/api/service/memberInfo';

/**
 * 预约服务-预约管理-预约列表
 */
export const API_SUBSCRIBE_INDEX = '/api/subscribe/index';
/**
 * 预约服务-预约管理-修改预约日期
 */
export const API_SUBSCRIBE_UPDATESUBSCRIBE = '/api/subscribe/updateSubscribe';
/**
 * 预约服务-预约管理-修改某个预约项目
 */
export const API_SUBSCRIBE_UPDATEOPTION = '/api/subscribe/updateOption';
/**
 * 预约服务-预约管理-推送某个预约项目
 */
export const API_SUBSCRIBE_SEND = '/api/subscribe/send';
/**
 * 预约服务-预约管理-通过,拒绝,取消某个预约项目
 */
export const API_SUBSCRIBE_UPDATESTATUS = '/api/subscribe/updateStatus';
/**
 * 预约服务-预约管理-更新确认
 */
export const API_SUBSCRIBE_UPDATEVIEW = '/api/subscribe/updateView';

/**
 * 预约服务 - 代客预约 - 获取次数
 */
export const API_SUBSCRIBE_MAKE_BASIC_NUM = '/api/subscribe/weekendSurplusNumbers'

/**
 * 预约服务 - 代客预约 - 预约
 */
export const API_SUBSCRIBE_ADD = '/api/subscribe/add'

/**
 * 预约服务 - 免提购物列表
 */
export const API_SUBSCRIBE_SHOPPING_LIST = '/api/subscribe/handsFreeList'

/**
 * 预约服务 - 免提购物 - 购物袋记录
 */
export const API_SUBSCRIBE_SHOPPING_BAGS = '/api/subscribe/handsfreeBagList'

/**
 * 预约服务 - 免提购物 - 添加购物袋
 */
export const API_SUBSCRIBE_SHOPPING_BAGS_ADD = '/api/subscribe/addEditHandfreeBag'

/**
 * 预约服务 - 免提购物 - 取货
 */
export const API_SUBSCRIBE_SHOPPING_PICK = '/api/subscribe/pickUp'
/**
 * 预约服务 - 免提购物 - 免提购物详情
 */
export const API_SERVICE_HANDSFREEINFO = '/api/service/handsfreeInfo'
/**
 * 预约服务 - 免提购物 - 编辑免提购物
 */
export const API_SERVICE_EDITHANDSFREE = '/api/service/editHandsfree'

/**
 * 预约服务 - 导购大使 - 列表
 */
export const API_SUBSCRIBE_SA_LIST = '/api/subscribe/saList'
/**
 * 预约服务 - 导购大使 - 确认入场
 */
export const API_SUBSCRIBE_SA_CHECKIN = '/api/subscribe/checkInSa'

/**
 * 预约服务 - 贵宾休息室 - 列表
 */
export const API_SUBSCRIBE_LOUNGE_LIST = '/api/subscribe/vipRoomList'

/**
 * 预约服务 - 贵宾休息室 - 预约时间段
 */
export const API_SUBSCRIBE_LOUNGE_ROOMDATA = '/api/subscribe/vipRoomData'

/**
 * 预约服务 - 贵宾休息室 - 确认入场
 */
export const API_SUBSCRIBE_LOUNGE_CHECKIN = '/api/subscribe/checkInVip'
/**
 * 预约服务 - 贵宾休息室 - 撤销入场
 */
export const API_SUBSCRIBE_LOUNGE_REVOKEIN = '/api/subscribe/revokeVip'
/**
 * 预约服务 - 贵宾休息室 - 确认出场
 */
export const API_SUBSCRIBE_LOUNGE_CHECKOUT = '/api/subscribe/checkOutVip'
/**
 * 预约服务 - 贵宾休息室 - 确认NoShow
 */
export const API_SUBSCRIBE_LOUNGE_NOSHOWVIP = '/api/subscribe/noShowVip'
/**
 * 预约服务 - 贵宾休息室 - 撤销NoShow
 */
export const API_SUBSCRIBE_LOUNGE_REVOKENOSHOWVIP = '/api/subscribe/revokeNoShowVip'

/**
 * 预约服务 - 贵宾休息室 - 修改到场人数和备注
 */
export const API_SUBSCRIBE_LOUNGE_UPDATE_CONTENT = '/api/subscribe/updateVipContent'
/**
 * 预约服务 - 贵宾休息室 - 贵宾休息室详情
 */
export const API_SERVICE_VIPROOMINFO = '/api/service/viproomInfo'
/**
 * 预约服务 - 贵宾休息室 - 编辑贵宾休息室
 */
export const API_SERVICE_EDITVIPROOM = '/api/service/editViproom'

/**
 * 预约服务 - 代客泊车 - 列表
 */
export const API_SUBSCRIBE_PARKING_LIST = '/api/subscribe/valetList'

/**
 * 预约服务 - 代客泊车 - 确认入场
 */
export const API_SUBSCRIBE_PARKING_CHECKIN = '/api/subscribe/checkInValet'
/**
 * 预约服务 - 代客泊车 - 撤销入场
 */
export const API_SUBSCRIBE_PARKING_REVOKEIN = '/api/subscribe/revokeValet'
/**
 * 预约服务 - 代客泊车 - 代客泊车详情
 */
export const API_SERVICE_VALETINFO = '/api/service/valetInfo'
/**
 * 预约服务 - 代客泊车 - 编辑代客泊车
 */
export const API_SERVICE_EDITVALET = '/api/service/editValet'
/**
 * 预约服务 - 导购大使 - 导购大使详情
 */
export const API_SERVICE_SAINFO = '/api/service/saInfo'
/**
 * 预约服务 - 导购大使 - 编辑导购大使
 */
export const API_SERVICE_EDITSA = '/api/service/editSa'

/**
 * 预约服务 - 服务余量 - 列表
 */
export const API_SUBSCRIBE_MARGIN_LIST = '/api/subscribe/optionSetList'

/**
 * 预约服务 - 服务余量 - 添加修改余量
 */
export const API_SUBSCRIBE_MARGIN_UPDATE = '/api/subscribe/addUpdateOptionSet'

/**
 * 预约服务 - 服务余量 - 删除余量
 */
export const API_SUBSCRIBE_MARGIN_DEL = '/api/subscribe/deleteOptionSet'

/**
 * 现场服务 - 服务余量 - 服务余量列表
 */
export const API_SUBSCRIBE_OPTIONRESIDUELIST = '/api/subscribe/optionResidueList';

/**
 * 现场服务-租赁服务-添加编辑租赁
 */
export const API_SERVICE_ADDEDITLEASE = '/api/service/addEditLease';
/**
 * 现场服务-租赁服务-租赁详情
 */
export const API_SERVICE_LEASEINFO = '/api/service/leaseInfo';
/**
 * 现场服务-租赁服务-取消租赁服务
 */
export const API_SERVICE_CANCELSERVICE = '/api/service/cancelService';
/**
 * 现场服务-租赁服务-删除租赁物品
 */
export const API_SERVICE_DELETELEASEITEM = '/api/service/deleteLeaseItem';
/**
 * 现场服务-租赁服务-租赁打印
 */
export const API_SERVICE_LEASEPRINT = '/api/service/leasePrint';
/**
 * 现场服务-租赁服务-一键归还
 */
export const API_SERVICE_GIVEBACK = '/api/service/giveBack';

/**
 * 现场服务-发票登记-添加编辑发票
 */
export const API_SERVICE_ADDEDITINVOICE = '/api/service/addEditInvoice';
/**
 * 现场服务-发票登记-发票详情
 */
export const API_SERVICE_INVOICEINFO = '/api/service/invoiceInfo';

/**
 * 现场服务-退税登记-添加编辑退税登记
 */
export const API_SERVICE_ADDEDITTAXREBATES = '/api/service/addEditTaxrebates';
/**
 * 现场服务-退税登记-退税登记详情
 */
export const API_SERVICE_TAXREBATESINFO = '/api/service/taxrebatesInfo';

/**
 * 现场服务-礼品包装-添加编辑礼品包装
 */
export const API_SERVICE_ADDEDITPACKAGE = '/api/service/addEditPackage';
/**
 * 现场服务-礼品包装-礼品包装详情
 */
export const API_SERVICE_PACKAGEINFO = '/api/service/packageInfo';

/**
 * 现场服务-商品快递-添加编辑商品快递
 */
export const API_SERVICE_ADDEDITEXPRESSAGE = '/api/service/addEditExpressage';
/**
 * 现场服务-商品快递-商品快递详情
 */
export const API_SERVICE_EXPRESSAGEINFO = '/api/service/expressageInfo';

/**
 * 现场服务-第三方积分-添加编辑第三方积分登记
 */
export const API_SERVICE_ADDEDITEXTERNALGIFT = '/api/service/addEditExternalgift';
/**
 * 现场服务-第三方积分-第三方积分登记详情
 */
export const API_SERVICE_EXTERNALGIFTINFO = '/api/service/externalgiftInfo';

/**
 * 现场服务-投诉建议-添加编辑投诉反馈
 */
export const API_SERVICE_ADDEDITCASES = '/api/service/addEditCases';
/**
 * 现场服务-投诉建议-投诉反馈详情
 */
export const API_SERVICE_CASESINFO = '/api/service/casesInfo';

/**
 * 现场服务-失物招领-失物招领列表
 */
export const API_SERVICE_LOSELIST = '/api/service/loseList';
/**
 * 现场服务-失物招领-添加编辑失物招领
 */
export const API_SERVICE_ADDEDITLOSE = '/api/service/addEditLose';
/**
 * 现场服务-失物招领-失物招领详情
 */
export const API_SERVICE_LOSEINFO = '/api/service/loseInfo';

/**
 * 现场服务-行李寄存-添加编辑行李寄存
 */
export const API_SERVICE_ADDEDITLUGGAGE = '/api/service/addEditLuggage';
/**
 * 现场服务-行李寄存-行李寄存详情
 */
export const API_SERVICE_LUGGAGEINFO = '/api/service/luggageInfo';
/**
 * 现场服务-行李寄存-领取
 */
export const API_SERVICE_LUGGAGERECEIVE = '/api/service/luggageReceive';

/**
 * 现场服务-其他服务-添加编辑其他服务登记
 */
export const API_SERVICE_ADDEDITOTHER = '/api/service/addEditOther';
/**
 * 现场服务-其他服务-其他服务详情
 */
export const API_SERVICE_OTHERINFO = '/api/service/otherInfo';

/**
 * 现场服务-服务记录-服务列表(搜索)
 */
export const API_SERVICE_QUERYLIST = '/api/service/queryList';
/**
 * 现场服务-服务记录-操作日志
 */
export const API_SERVICE_LOGLIST = '/api/service/logList';

/**
 * 兑换管理-可兑换卡券列表
 */
export const API_TICKET_CONVERTTICKET = '/api/ticket/convertTicket';
/**
 * 兑换管理-活动发券列表
 */
export const API_TICKET_ACTLIST = '/api/ticket/actList';
/**
 * 兑换管理-已兑换或已过期卡券
 */
export const API_TICKET_USETICKET = '/api/ticket/useTicket';
/**
 * 兑换管理-兑换
 */
export const API_TICKET_EXCHANGETICKET = '/api/ticket/exchangeTicket';
/**
 * 兑换管理-扫二维码兑换
 */
export const API_TICKET_QRCODEEXCHANGETICKET = '/api/ticket/qrcodeExchangeTicket';
/**
 * 兑换管理-发券
 */
export const API_TICKET_SENDTICKET = '/api/ticket/sendTicket';
/**
 * 兑换管理-补券
 */
export const API_TICKET_REPAIRTICKET = '/api/ticket/repairTicket';

/**
 * 特卖入场-列表
 */
export const API_DIGTAILQ_LIST = '/api/digtailQ';
/**
 * 特卖入场-进入控制台
 */
export const API_DIGTAILQ_CONSOLE = '/api/digtailQ/console';